export const userData = [
    {
        name: 'Jan',
        "Active User": 4000,
    },
    {
        name: 'Feb',
        "Active User": 5000,
    },
    {
        name: 'Mar',
        "Active User": 4000,
    },
    {
        name: 'Apr',
        "Active User": 4000,
    },
    {
        name: 'May',
        "Active User": 2000,
    },
    {
        name: 'Jun',
        "Active User": 1000,
    },
    {
        name: 'Jul',
        "Active User": 2000,
    },
    {
        name: 'Aug',
        "Active User": 3000,
    },
    {
        name: 'Sep',
        "Active User": 1500,
    },
    {
        name: 'Oct',
        "Active User": 4000,
    },
    {
        name: 'Nov',
        "Active User": 2000,
    },
    {
        name: 'Dec',
        "Active User": 3000,
    }

];

export const productData = [
    {
        name: 'Jan',
        "Sales": 4000,
    },
    {
        name: 'Feb',
        "Sales": 3000,
    },
    {
        name: 'Mar',
        "Sales": 5000,
    }
];


export const userRows = [
    { id: 1, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 2, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 3, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 4, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 5, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 6, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 7, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 8, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 9, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },
    { id: 10, userName: 'Jon Snow', avatar: "https://www.w3schools.com/howto/img_avatar.png", email: "jon@gmail.com", status: "active", transaction: "$120.00" },

];


export const productRows = [
    { id: 1, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 2, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 3, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 4, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 5, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 6, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 7, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 8, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 9, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },
    { id: 10, name: 'Apple Airpods', img: "https://www.w3schools.com/howto/img_avatar.png", stock: 123, status: "active", price: "$120.00" },

];